import { Component, OnInit } from '@angular/core';
import { faAngleDown } from '@fortawesome/pro-light-svg-icons';
import { MetaSetterService } from 'src/app/general/meta-setter.service';
import { GolfPlayerFutures } from 'src/app/golf-player-futures.model';
import { GolfTournament } from 'src/app/golf-tournament.model';
import { SportDataService } from 'src/app/sport-data.service';
import { LocalisationService } from 'src/app/localisation.service';
import { BlogService } from 'src/app/blog.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-golf-head-to-head-page',
	templateUrl: './golf-head-to-head-page.component.html',
	styleUrls: ['./golf-head-to-head-page.component.scss']
})
export class GolfHeadToHeadPageComponent implements OnInit {

	faAngleDown = faAngleDown;

    golfH2HMatrix = [];
    golfH2HLoading = true;
    golfH2HError = false;
    golfH2HNoMatchup = false;

    h2hRoundOption = 'r1';

	tournamentData: GolfTournament = null;

    setH2HRoundOption(value: string) {this.h2hRoundOption = value};

    h2hPlayerA = null;
    h2hPlayerB = null;

    h2hData = {};
    
    h2hSearches = {
        playerA: '',
        playerB: ''
    }

	selectablePlayers: Array<Array<GolfPlayerFutures>> = [[], []];

    h2hPlayerADropdownOpen = false;
    h2hPlayerBDropdownOpen = false;

    probabilityOption = 'percent';

	environment = environment;

	trustedDesc: SafeHtml;
	trustedCopy: SafeHtml;

    toggleH2HPlayerADropdown() {this.h2hPlayerADropdownOpen = !this.h2hPlayerADropdownOpen}
    toggleH2HPlayerBDropdown() {this.h2hPlayerBDropdownOpen = !this.h2hPlayerBDropdownOpen}

    h2hProbDisplay(playerNo: number) {
        var rawValue;
        if (playerNo == 0) {
            rawValue = this.h2hData[`tie${this.h2hRoundOption == 'r1' ? '1R' : ''}`]
        } else {
            rawValue = this.h2hData[`win${playerNo == 1 ? 'A' : 'B'}${this.h2hRoundOption == 'r1' ? '1R' : ''}`]
        }

        return this.probConversion(rawValue, 1)
    }



    playerFitsSearch(playerNo: number) {
        return (player: GolfPlayerFutures) => {
            var searchQuery = (playerNo == 1 ? this.h2hSearches.playerA : this.h2hSearches.playerB);
            if (searchQuery == "") {
                return true;
            }

            return (player.playerFirstName + ' ' + player.playerLastName).toLowerCase().includes(searchQuery.toLowerCase());
        }
        
    }

    retrieveH2HData() {
        var matchupRow;
        if (this.golfH2HMatrix.some(matchup => matchup.player1 == this.h2hPlayerA.playerId && matchup.player2 == this.h2hPlayerB.playerId)) {
            matchupRow = this.golfH2HMatrix.find(matchup => matchup.player1 == this.h2hPlayerA.playerId && matchup.player2 == this.h2hPlayerB.playerId);

            this.h2hData = {
                winA: matchupRow.player1WinProb,
                winB: matchupRow.player2WinProb,
                tie: matchupRow.tieProb,
                winA1R: matchupRow.player1WinProb_R1,
                winB1R: matchupRow.player2WinProb_R1,
                tie1R: matchupRow.tieProb_R1
            }
            this.golfH2HNoMatchup = false;
        } else if (this.golfH2HMatrix.some(matchup => matchup.player1 == this.h2hPlayerB.playerId && matchup.player2 == this.h2hPlayerA.playerId)) {
            matchupRow = this.golfH2HMatrix.find(matchup => matchup.player1 == this.h2hPlayerB.playerId && matchup.player2 == this.h2hPlayerA.playerId);

            this.h2hData = {
                winA: matchupRow.player2WinProb,
                winB: matchupRow.player1WinProb,
                tie: matchupRow.tieProb,
                winA1R: matchupRow.player2WinProb_R1,
                winB1R: matchupRow.player1WinProb_R1,
                tie1R: matchupRow.tieProb_R1
            }
            this.golfH2HNoMatchup = false;
        } else {
            this.golfH2HNoMatchup = true;
        }
            
    }

    setH2HPlayer(playerNo, player) {
        if (playerNo == 1) {
            this.h2hPlayerA = player;
            this.h2hSearches.playerA = '';
            this.h2hPlayerADropdownOpen = false;
        } else {
            this.h2hPlayerB = player;
            this.h2hSearches.playerB = '';
            this.h2hPlayerBDropdownOpen = false;
        }

        
        this.retrieveH2HData();
    }

	countryLookup = {
		"ALBANIA": "ALB",
		"ARGENTINA": "ARG",
		"AUSTRALIA": "AUS",
		"AUSTRIA": "AUT",
		"BAHAMAS": "BHS",
		"BAHRAIN": "BHR",
		"BANGLADESH": "BGD",
		"BELGIUM": "BEL",
		"BERMUDA": "BMU",
		"BOTSWANA": "BWA",
		"BRAZIL": "BRA",
		"CANADA": "CAN",
		"CAYMAN ISLANDS": "CYM",
		"CHILE": "CHI",
		"CHINA": "CHN",
		"CHINESE TAIPEI": "TWN",
		"COLOMBIA": "COL",
		"COSTA RICA": "CRI",
		"CZECH REPUBLIC": "CZE",
		"DENMARK": "DEN",
		"DOMINICAN REPUBLIC": "DOM",
		"ECUADOR": "ECU",
		"ENGLAND": "ENG",
		"ESTONIA": "EST",
		"FIJI": "FIJ",
		"FINLAND": "FIN",
		"FRANCE": "FRA",
		"GERMANY": "DEU",
		"GUATEMALA": "GTM",
		"HONG KONG": "HKG",
		"ICELAND": "ISL",
		"INDIA": "IND",
		"INDONESIA": "IDN",
		"IRELAND": "IRL",
		"ISLE OF MAN": "IMN",
		"ITALY": "ITA",
		"JAPAN": "JPN",
		"JORDAN": "JOR",
		"KENYA": "KEN",
		"MALAYSIA": "MYS",
		"MAURITIUS": "MUS",
		"MEXICO": "MEX",
		"MONACO": "MCO",
		"MOROCCO": "MAR",
		"MYANMAR": "MMR",
		"NAMIBIA": "NAM",
		"NETHERLANDS": "NED",
		"NEW ZEALAND": "NZL",
		"NORTHERN IRELAND": "NIR",
		"NORWAY": "NOR",
		"OMAN": "OMN",
		"PAKISTAN": "PAK",
		"PANAMA": "PAN",
		"PARAGUAY": "PAR",
		"PHILIPPINES": "PHL",
		"POLAND": "POL",
		"PORTUGAL": "PRT",
		"PUERTO RICO": "PRI",
		"QATAR": "QAT",
		"SAUDI ARABIA": "SAU",
		"SCOTLAND": "SCO",
		"SERBIA": "SRB",
		"SINGAPORE": "SGP",
		"SLOVAKIA": "SVK",
		"SOUTH AFRICA": "RSA",
		"SOUTH KOREA": "KOR",
		"SPAIN": "ESP",
		"SRI LANKA": "LKA",
		"SWAZILAND": "SWZ",
		"SWEDEN": "SWE",
		"SWITZERLAND": "CHE",
		"TAIWAN": "TWN",
		"TANZANIA": "TZA",
		"THAILAND": "THA",
		"TURKEY": "TUR",
		"UGANDA": "UGA",
		"UNITED ARAB EMIRATES": "ARE",
		"UNITED STATES": "USA",
		"USA": "USA",
		"VENEZUELA": "VEN",
		"VIETNAM": "VNM",
		"WALES": "WAL",
		"ZAMBIA": "ZMB",
		"ZIMBABWE": "ZIM",
	};

    toggleProbabilityOption() {
        if (this.probabilityOption == 'percent') {
            this.probabilityOption = 'odds';
        } else {
            this.probabilityOption = 'percent'
        }
    }

    probConversion = (value: number, numPctDigits: number) => {
        if (this.probabilityOption == 'percent') {
            if (numPctDigits == 1 && value < 0.001) {
                return "<0.1%";
            }
            return (value * 100).toFixed(numPctDigits) + '%';
        } else {
            if (value == 0) {
                return "-";
            }

			return this.localisationService.convertDecimalOdds(1/value);
        }
    }

	calculateSelectablePlayers(): void {
		if (!this.tournamentData || !this.tournamentData.FuturesData) {
			this.selectablePlayers = [[], []];
		}
		[0,1].forEach(n => {
			this.selectablePlayers[n] = this.tournamentData.FuturesData.filter(p => this.playerFitsSearch(n + 1)(p)).sort((a,b) => {
				if (a.playerLastName.toUpperCase().localeCompare(b.playerLastName.toLowerCase()) !== 0) {
					return a.playerLastName.toUpperCase().localeCompare(b.playerLastName.toLowerCase());
	
				}
				return a.playerFirstName.toUpperCase().localeCompare(b.playerFirstName.toLowerCase());
			})
		})
		
	}

    getGolfH2HMatrix() {
        this.golfH2HLoading = true;
        this.golfH2HError = false;
		this.tournamentData = null;
		this.golfH2HMatrix = null;

		this.blogService.getAppSettings("golf-h2h")
			.subscribe(settings => {
				this.metaSetter.setMeta({
					title: settings.app_title,
					seoTitle: settings.seo_title,
					description: settings.seo_description || settings.app_description,
					metaImageURL: settings.thumbnail?.url || environment.defaultMetaImage,
					canonicalURL: environment.canonicalDomain + "/sport-hub/golf/h2h?tourn=next",
				});

				this.trustedDesc = this.sanitiser.bypassSecurityTrustHtml(settings.app_page_subheader || "");
				this.trustedCopy = this.sanitiser.bypassSecurityTrustHtml(settings.subheading_description || "");
			}, () => {
				this.metaSetter.setMeta({
					title: environment.siteTitle,
					description: environment.defaultMetaDescription,
					metaImageURL: environment.defaultMetaImage,
					canonicalURL: environment.canonicalDomain + "/sport-hub/golf/h2h?tourn=next",
				})
			});

		if (typeof document !== "undefined") {

			this.sportDataService.getNextGolfTournamentData()
				.subscribe(tournamentData => {
					this.tournamentData = tournamentData;
					const tournamentID = tournamentData.tournamentId;
					const season = tournamentData.year;
	
					this.sportDataService.getGolfH2HMatrix(tournamentID, season)
						.subscribe(matrix => {
							this.golfH2HMatrix = matrix;
							if (this.golfH2HMatrix.length == 0) {
								this.golfH2HLoading = false;
								this.golfH2HError = true;
							} else {
								this.h2hPlayerA = this.tournamentData.FuturesData.find(player => player.playerId == this.golfH2HMatrix[0].player1);
								this.h2hPlayerB = this.tournamentData.FuturesData.find(player => player.playerId == this.golfH2HMatrix[0].player2);
								this.golfH2HLoading = false;
	
								this.calculateSelectablePlayers();
					
								this.retrieveH2HData();
							}
						
						}, (err) => {
							this.golfH2HLoading = false;
							this.golfH2HError = true;
						});
				}, () => {
					this.golfH2HError = true;
				});

		}
        
    }

   

	constructor(
		private sportDataService: SportDataService,
		private metaSetter: MetaSetterService,
		private localisationService: LocalisationService,
		private blogService: BlogService,
		private sanitiser: DomSanitizer,
	) { }

	ngOnInit(): void {
		this.getGolfH2HMatrix();
	}

}
